/**makeSelectLogs
 * Combine all reducers in this file and export the combined reducers.
 */

import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import history from '../utils/history';

import {State as LoginState} from '../pages/login/interfaces';
import {State as DriverState} from '../pages/driverManagement/interfaces';

import LoginReducer from '../pages/login/reducer';
import DriverReducer from '../pages/driverManagement/reducer';

export interface Store {
  login: LoginState;
  driver: DriverState;
  router: any;
}

export default combineReducers<Store>({
  login: LoginReducer,
  driver: DriverReducer,
  router: connectRouter(history),
});
